import React from "react";
import { MessageSquareText } from "lucide-react";
import type { IHostProfile } from "../types";
import HostAvatar from "./HostAvatar";

interface IHostProfileSectionProps {
  hostDetails: IHostProfile;
}

const HostProfileSection: React.FC<IHostProfileSectionProps> = ({
  hostDetails,
}) => (
  <div className="space-y-6 mb-8 lg:mb-12 mt-8">
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-8">
        <div className="flex items-start gap-6">
          <div className="flex-shrink-0">
            <HostAvatar
              imageUrl={hostDetails.image?.url}
              firstName={hostDetails.first_name}
              lastName={hostDetails.last_name}
              size="md"
            />
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h1 className="text-2xl font-bold text-ink-black mb-1">
                  Hello, I'm {hostDetails.first_name}
                </h1>
                <p className="text-ink-secondary text-sm">
                  Professional Host • {hostDetails.total_booking} completed
                  stays
                </p>
              </div>

              {hostDetails.host_status === "verified" && (
                <div className="flex items-center bg-green-50 text-success-verified px-3 py-1.5 rounded-full text-sm font-medium border border-green-200">
                  <img
                    className="w-4 h-4 mr-1.5"
                    alt="verified"
                    src="/verified.png"
                  />
                  Identity verified
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 py-6">
        <div className="flex items-center text-ink-dark mb-4">
          <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full mr-4">
            <MessageSquareText className="w-5 h-5 text-ink-secondary" />
          </div>
          <div>
            <p className="font-medium text-ink-black">Languages</p>
            <p className="text-sm text-ink-secondary">Bangla, English</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HostProfileSection;
